module.exports = __webpack_public_path__ + "img/jiaotong.4bc4cffd.png";